import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useRef, useState } from 'react';
import { useDefaultMode } from './useDefaultMode';
import { useInOutMode } from './useInOutMode';
import { useOutInMode } from './useOutInMode';
export function useSwitchTransition(state, timeout, mode) {
  const keyRef = useRef(0);
  const firstDefaultItem = {
    state,
    key: keyRef.current,
    stage: 'enter'
  };
  const [list, setList] = useState([firstDefaultItem]);
  // for default mode only
  useDefaultMode({
    state,
    timeout,
    keyRef,
    mode,
    list,
    setList
  });
  // for out-in mode only
  useOutInMode({
    state,
    timeout,
    keyRef,
    mode,
    list,
    setList
  });
  // for in-out mode only
  useInOutMode({
    state,
    timeout,
    keyRef,
    mode,
    list,
    setList
  });
  function transition(renderCallback) {
    return list.map(item => _jsx(Fragment, {
      children: renderCallback(item.state, item.stage)
    }, item.key));
  }
  return transition;
}